import client from "./client";

const getSettlementCycles = () => client.get("settlement/plan/view");

export default { getSettlementCycles };
